import React from 'react';

interface DeleteConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  itemName: string;
  itemType: string;
  isLoading?: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  show,
  onHide,
  onConfirm,
  itemName,
  itemType,
  isLoading = false
}) => {
  if (!show) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header bg-danger text-white border-0">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <i className="bi bi-exclamation-triangle-fill fs-2"></i>
              </div>
              <div>
                <h5 className="modal-title mb-0">Confirm Delete</h5>
                <small className="opacity-75">This action cannot be undone</small>
              </div>
            </div>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onHide}
              disabled={isLoading}
            ></button>
          </div>
          
          <div className="modal-body p-4">
            <div className="text-center mb-4">
              <div className="mb-3">
                <i className="bi bi-trash3 text-danger" style={{ fontSize: '3rem' }}></i>
              </div>
              <h6 className="text-dark mb-3">
                Are you sure you want to delete this {itemType}?
              </h6>
              <div className="bg-light rounded p-3 mb-3">
                <strong className="text-primary">{itemName}</strong>
              </div>
            </div>
          </div>
          
          <div className="modal-footer border-0 p-4">
            <div className="d-flex gap-2 w-100">
              <button 
                type="button" 
                className="btn btn-outline-secondary flex-fill"
                onClick={onHide}
                disabled={isLoading}
              >
                <i className="bi bi-x-circle me-2"></i>
                Cancel
              </button>
              <button 
                type="button" 
                className="btn btn-danger flex-fill"
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Deleting...
                  </>
                ) : (
                  <>
                    <i className="bi bi-trash3 me-2"></i>
                    Yes, Delete
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
